import { assign, sendParent } from '@monofront/xstate-v4';
import { SELECT_SHIPPING_METHOD_TRANSITIONS } from '../transitions';
import {
  ISelectPickupPointContext,
  IOpenPickupModal,
  ISelectPickupPoint,
  IPickupListReceivedEvent,
} from './types';

export const assignInitValuesForModal = assign<
  ISelectPickupPointContext,
  IOpenPickupModal
>({
  shippingMethods: (context, event) => event.methods || context.shippingMethods,
  address: (_, event) => event.address,
});

export const assignPickupSelected = assign<
  ISelectPickupPointContext,
  ISelectPickupPoint
>({
  pickupPointSelected: (_, event) => event.pickupPointSelected,
  pickupAddress: (_, event) => event.pickupAddress,
  shipmentMethodCode: (_, event) => event.shipmentMethodCode,
});

export const assignPickupListReceived = assign<
  ISelectPickupPointContext,
  IPickupListReceivedEvent
>({
  pickupPoints: (_, event) => event.data.data.getDropOffPoints,
});

export const sendPickupSelectedToParent = sendParent<
  ISelectPickupPointContext,
  ISelectPickupPoint
>((_, event) => ({
  ...event,
  type: SELECT_SHIPPING_METHOD_TRANSITIONS.SELECT_PICKUP_POINT,
}));

export enum SELECT_PICKUP_POINT_EXTERNAL_ACTIONS {
  trackOpenModal = 'trackOpenModal',
  trackCloseModal = 'trackCloseModal',
}
